import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/organisations/organisation-application-question-templates";
import {
  SET_IS_FETCHING_APPLICATION_QUESTION_TEMPLATES,
  SET_ORGANISATION_APPLICATION_QUESTION_TEMPLATES
} from "@/store/modules/organisations/organisation-application-question-templates/mutations";

export const FETCH_APPLICATION_QUESTION_TEMPLATES =
  "FETCH_APPLICATION_QUESTION_TEMPLATES";
export const CREATE_APPLICATION_QUESTION_TEMPLATE =
  "CREATE_APPLICATION_QUESTION_TEMPLATE";
export const EDIT_APPLICATION_QUESTION_TEMPLATE =
  "EDIT_APPLICATION_QUESTION_TEMPLATE";

const actions = {
  async [FETCH_APPLICATION_QUESTION_TEMPLATES]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_APPLICATION_QUESTION_TEMPLATES, isLoading),
      setDataFunction: ({ data }) =>
        commit(SET_ORGANISATION_APPLICATION_QUESTION_TEMPLATES, data)
    });
  },
  async [CREATE_APPLICATION_QUESTION_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).add(data), dispatch);
  },
  async [EDIT_APPLICATION_QUESTION_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).edit(data), dispatch);
  }
};

export default actions;
